/* Chemiseed link logic. Added 15 September 2026 (theme v21), revised 10 October 2026 (H-08).
   1. Outbound links get UTM parameters only at the moment they are activated (click, middle-click
      auxclick, keyboard Enter), and the original href is put back straight afterwards, so "copy link
      address" and a right-click never pick up our tags:
        utm_source=chemiseed.com, utm_medium=referral,
        utm_campaign=site-<page locale>-<page market>-<page group>  (from the page, never the visitor),
        utm_content=<section type or data-cs-placement>-<link text slug>  (lowercase, at most 40 characters).
      Never tagged: internal links, links that already carry utm_ parameters, links marked data-no-utm,
      WhatsApp links and share intents, archive.org, the store's own CDN files, and citation or
      reference links (government, university and publisher domains, DOI, journals, FAO/CGIAR/CABI,
      MPOB, links inside a reference list or a <cite>, links styled as citations such as .crs-cite).
   2. Every CTA click pushes one dataLayer event, cs_cta_click, with cta_type, cta_label, link_url,
      link_domain and link_placement. Tag Manager forwards it to GA4 and derives phone_click and
      email_click from it; the page context (cs_page_group, cs_page_handle, cs_locale, cs_market) is
      pushed by layout/theme.liquid before GTM loads.
   3. Indonesia market pages (/en-id, /id-id) and Indonesian-language pages (/id; added 17 Oct 2026): WhatsApp links to the Malaysian number
      wa.me/60172374058 are pointed at the Indonesia contact wa.me/6287778374714 (any ?text= is kept).
      When such a link shows the Malaysian number as text (+60 17-237 4058, +60172374058, 60172374058,
      017-237 4058 and similar spacing), that text inside the link reads +62 877 7837 4714 (10 Oct 2026).
      Only text nodes inside the rewritten link change; nothing else on the page.
   4. The same page context is set as Microsoft Clarity custom tags once Clarity has loaded.
   5. Market-preserving internal links (H-16, 10 October 2026). On a page under /en-id, /id-id, /ms or /id,
      a link to this site's storefront pages (/, /pages, /products, /collections, /blogs, /search,
      /policies) that has no locale or market prefix gets the page's prefix for the moment it is
      activated (click, middle-click, keyboard Enter); the original href is put back straight afterwards,
      as with the UTM tags. Example: on /id-id, /pages/contact-us opens /id-id/pages/contact-us. On /id-id a
      link under /id (the Indonesian root of the Malaysia and International market) opens under /id-id.
      Never changed: links that already carry a prefix (/ms, /id, /en-id, /id-id; /id only on /id-id),
      /cdn, /cart, /account, /checkout(s), /apps, /tools, /services, file URLs (a path ending in an
      extension), anchors, mailto/tel, other sites, and links marked hreflang, download or data-no-locale.
      The cs_cta_click event keeps the link's own href as link_url.
   No personal data is read or written. */
(function () {
  'use strict';
  if (window.Shopify && window.Shopify.designMode) { return; }
  var d = document, L = window.location;
  var ctx = window.csPage || {};
  var OWN = /(^|\.)chemiseed\.com$/i;
  var WA = /(^|\.)(wa\.me|whatsapp\.com)$/i;
  var SKIP = /(^|\.)(wa\.me|whatsapp\.com|archive\.org|cdn\.shopify\.com|shopifycdn\.com)$/i;
  var SHARE = /(linkedin\.com\/sharing|twitter\.com\/intent|x\.com\/intent|facebook\.com\/sharer|facebook\.com\/dialog|wa\.me\/\?text=|whatsapp\.com\/send\/?\?text=)/i;
  var SOCIAL = /(^|\.)(facebook\.com|fb\.com|instagram\.com|tiktok\.com|linkedin\.com|youtube\.com|youtu\.be|twitter\.com|x\.com|substack\.com|threads\.net)$/i;
  var SHOPEE = /(^|\.)shopee\.[a-z.]+$/i;
  var KZ = /(^|\.)kudzuseeds\.com$/i;
  /* Citation and reference hosts: never tagged. Government (.gov, .gov.xx and the national variants
     .go.xx, .gob.xx, .gouv.xx, .govt.xx), universities (.edu, .edu.xx, .ac.xx), DOI and publishers. */
  var CITE_TLD = /(^|\.)(gov|edu)(\.[a-z]{2})?$|(^|\.)(ac|go|gob|gouv|govt)\.[a-z]{2}$/i;
  var CITE_HOST = /(^|\.)(doi\.org|europepmc\.org|sciencedirect\.com|springer\.com|wiley\.com|mdpi\.com|frontiersin\.org|tandfonline\.com|cambridge\.org|oup\.com|nature\.com|researchgate\.net|academia\.edu|jstor\.org|crossref\.org|semanticscholar\.org|tropicalforages\.info|fao\.org|cgiar\.org|cabi\.org|cabidigitallibrary\.org|iopscience\.iop\.org|agritrop\.cirad\.fr|prota4u\.org)$/i;
  var CITE_ANY = /pubmed|scholar\.google\.|plantuse|prota4u|pertanika|journal|scielo|ajol\.info|doaj\.org|arxiv\.org|biorxiv\.org|ssrn\.com|plos\.org|hindawi\.com|sagepub\.com|elsevier\.com/i;
  var REF_SEL = 'cite, .references, .reference-list, .refs, .cs-refs, .cs-ref-table, .csev-refs, .ev-cite, .crs-cite, [class*="-cite"], [class*="__cite"], [data-cite], .footnotes, #references, [data-cs-refs], [role="doc-bibliography"], [role="doc-endnotes"]';
  var REF_HEAD = /^\s*(?:(?:scientific|evidence|key|further)\s+)?(?:references?|sources?|citations?|bibliography|works cited|literature cited|rujukan(?: saintifik)?|sumber(?: rujukan| bukti)?|referensi(?: ilmiah)?|daftar pustaka|pustaka)(?:\s+and\s+further\s+reading)?\s*(?:\([^)]*\))?\s*:?\s*$/i;
  var LOC = '^\\/(?:[a-z]{2}(?:-[a-z]{2})?\\/)?';
  var LEAD = new RegExp(LOC + 'pages\\/(contact-us|consultation-request|sample-request|become-a-distributor|distributor-application|event-meeting-request|field-trial-request|institutional-buyer-intake|project-intake|request-availability|vendor-supplier-contact)(?:$|[\\/?#])', 'i');
  var TOOL = new RegExp(LOC + 'pages\\/(tools|how-can-we-help|unit-converter|[a-z0-9-]*calculator[a-z0-9-]*|[a-z0-9-]*planner[a-z0-9-]*)(?:$|[\\/?#])', 'i');
  var DOC = new RegExp(LOC + '(pages\\/(e-catalogue|e-catalog|document-center|knowledge-hub|evidence-hub)|files\\/)(?:$|[\\/?#.])', 'i');
  var CTA = '[data-cs-cta], .button, .btn, [role="button"], [class*="cta"], [class*="button"], [class*="__link--primary"], .cs-mobilebar a, #cs-mobilebar a';
  var WA_MY = '60172374058', WA_ID = '6287778374714', WA_ID_TEXT = '+62 877 7837 4714';
  /* The Malaysian number as text: country code 60, +60, (60) or (+60), or a leading 0, then 17 237 4058 with any
     spaces, no-break spaces, dots, hyphens or brackets between digits; not part of a longer digit run. A bracket
     that opens before the whole number ("(+60 17-237 4058)") is kept, so brackets stay balanced. */
  var WA_MY_TEXT = /(^|[^0-9+])(\(\+?6[\s\u00a0.\-]*0\)|\+?6[\s\u00a0().\-]*0|0)[\s\u00a0().\-]*1[\s\u00a0().\-]*7[\s\u00a0().\-]*2[\s\u00a0().\-]*3[\s\u00a0().\-]*7[\s\u00a0().\-]*4[\s\u00a0().\-]*0[\s\u00a0().\-]*5[\s\u00a0().\-]*8(?![0-9])/g;

  function clean(v, max) {
    v = String(v == null ? '' : v);
    if (v.normalize) { v = v.normalize('NFD').replace(/[̀-ͯ]/g, ''); }
    v = v.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    return v.slice(0, max || 60).replace(/-+$/g, '');
  }
  /* Page locale and market from the page itself: the values layout/theme.liquid prints
     (csPage.page_locale, csPage.page_market), else the URL root (/ms, /id, /en-id, /id-id). */
  function pathRoot(path) {
    var m = /^\/(en-id|id-id|ms|id)(?=\/|$)/i.exec(path || '/');
    return m ? m[1].toLowerCase() : '';
  }
  function pageLocale(path) {
    if (ctx.page_locale) { return clean(ctx.page_locale, 5) || 'en'; }
    var r = pathRoot(path);
    return r === 'id-id' || r === 'id' ? 'id' : (r === 'ms' ? 'ms' : 'en');
  }
  function pageMarket(path) {
    if (ctx.page_market) { return clean(ctx.page_market, 5) || 'my'; }
    var r = pathRoot(path);
    return r === 'en-id' || r === 'id-id' ? 'id' : 'my';
  }
  function group() { return clean(ctx.page_group || ctx.page_type || 'page', 30) || 'page'; }
  function campaign(path) {
    return 'site-' + pageLocale(path == null ? L.pathname : path) + '-' + pageMarket(path == null ? L.pathname : path) + '-' + group();
  }
  function isIndonesiaPage() { return pageMarket(L.pathname) === 'id' || pageLocale(L.pathname) === 'id'; }
  function closestSafe(a, s) { try { return a.closest(s); } catch (e) { return null; } }
  /* Readable section name: data-cs-placement, a known region, the section key from the template,
     or, for auto-named keys such as custom_liquid_wBgkAJ, the first cs- class inside the section. */
  function sectionName(s) {
    var id = s.id || '', i = id.lastIndexOf('__');
    var key = i > -1 ? id.slice(i + 2) : id.replace('shopify-section-', '');
    var auto = /^(.+?)_([A-Za-z0-9]{6})$/.exec(key);
    if (auto && /[A-Z0-9]/.test(auto[2])) {
      var el = null;
      try { el = s.querySelector('[class^="cs-"], [class*=" cs-"]'); } catch (e) { el = null; }
      if (el) {
        var cls = (el.getAttribute('class') || '').split(/\s+/);
        for (var k = 0; k < cls.length; k++) {
          if (/^cs-[a-z0-9-]+/i.test(cls[k])) { return cls[k].split('__')[0].split('--')[0]; }
        }
      }
      return auto[1];
    }
    return key;
  }
  function placement(a) {
    var c = function (s) { return closestSafe(a, s); };
    var own = c('[data-cs-placement]');
    if (own) { var v = clean(own.getAttribute('data-cs-placement'), 20); if (v) { return v; } }
    if (c('#cs-mobilebar, .cs-mobilebar')) { return 'mobilebar'; }
    if (c('#whatsappButton, .whatsapp-float, .cs-whatsapp')) { return 'whatsapp-button'; }
    if (c('.announcement-bar, .utility-bar, [id^="shopify-section-"][id*="announcement"]')) { return 'announcement'; }
    if (c('header, .header, .menu-drawer, [id^="shopify-section-"][id*="__header"]')) { return 'header'; }
    if (c('footer, .footer, [id^="shopify-section-"][id*="__footer"]')) { return 'footer'; }
    var s = c('[id^="shopify-section-"]');
    if (s && s.id) { return clean(sectionName(s), 20) || 'body'; }
    return 'body';
  }
  function label(a) {
    var t = a.getAttribute('aria-label') || a.getAttribute('title') || (a.textContent || '');
    if (!t.trim()) { var img = a.querySelector('img[alt]'); if (img) { t = img.getAttribute('alt') || ''; } }
    return t.replace(/\s+/g, ' ').trim().slice(0, 100);
  }
  function contentTag(where, text) {
    var p = clean(where, 20) || 'body';
    var room = 40 - p.length - 1;
    var slug = room > 0 ? clean(text, room) : '';
    return slug ? p + '-' + slug : p;
  }
  function content(a) { return contentTag(placement(a), label(a)); }
  function parse(a) {
    var href = a.getAttribute('href');
    if (!href) { return null; }
    href = href.trim();
    if (/^(javascript:|#)/i.test(href)) { return null; }
    var u;
    try { u = new URL(href, L.href); } catch (e) { return null; }
    return { raw: href, u: u, host: (u.hostname || '').toLowerCase(), proto: u.protocol };
  }
  function isCitationUrl(p) {
    if (!p) { return false; }
    var h = p.host;
    return CITE_TLD.test(h) || CITE_HOST.test(h) || CITE_ANY.test(h);
  }
  function inReferenceList(a) {
    if (closestSafe(a, REF_SEL)) { return true; }
    var node = closestSafe(a, 'li, p, td, dd, dt, div') || a.parentElement;
    for (var depth = 0; node && depth < 5 && node !== d.body; depth++) {
      var s = node.previousElementSibling, n = 0;
      while (s && n < 40) {
        if (/^H[2-6]$/.test(s.tagName)) { return REF_HEAD.test(s.textContent || ''); }
        s = s.previousElementSibling; n++;
      }
      node = node.parentElement;
    }
    return false;
  }
  function isOwn(p) { return OWN.test(p.host) || p.host === L.hostname.toLowerCase(); }
  /* 5. Market-preserving internal links. */
  var SITE = /^(www\.)?chemiseed\.com$/i;
  var PREFIXED = /^\/(en-id|id-id|ms|id)(?=\/|$)/i;
  var ROUTE = /^\/(?:$|(?:pages|products|collections|blogs|search|policies)(?:$|\/))/i;
  var NEVER = /^\/(?:cdn|cart|account|checkouts?|apps|tools|services)(?:$|[\/?#.])/i;
  function localPath(path) { return ROUTE.test(path) && !NEVER.test(path) && !/\.[a-z0-9]+$/i.test(path); }
  /* Returns the href with the page's locale/market prefix, or null when the link must not change. */
  function localizedHref(p, pagePath, a) {
    var root = pathRoot(pagePath == null ? L.pathname : pagePath);
    if (!root || !p) { return null; }
    if (p.proto !== 'http:' && p.proto !== 'https:') { return null; }
    if (!(SITE.test(p.host) || p.host === String(L.hostname || '').toLowerCase())) { return null; }
    if (a && a.hasAttribute && (a.hasAttribute('hreflang') || a.hasAttribute('download') || a.hasAttribute('data-no-locale'))) { return null; }
    if (/^#/.test(p.raw)) { return null; }
    var path = p.u.pathname || '/', np = null, m = PREFIXED.exec(path);
    if (m) {
      if (root === 'id-id' && m[1].toLowerCase() === 'id') {
        var rest = path.slice(3) || '/';
        if (localPath(rest)) { np = '/id-id' + (rest === '/' ? '' : rest); }
      }
    } else if (localPath(path)) {
      np = '/' + root + (path === '/' ? '' : path);
    }
    if (np == null) { return null; }
    var tail = p.u.search + p.u.hash;
    return (/^\/(?!\/)/.test(p.raw) ? '' : p.u.protocol + '//' + p.u.host) + np + tail;
  }
  function classify(p) {
    if (!p) { return null; }
    if (p.proto === 'tel:') { return 'phone'; }
    if (p.proto === 'mailto:') { return 'email'; }
    if (p.proto === 'whatsapp:') { return 'whatsapp'; }
    if (p.proto !== 'http:' && p.proto !== 'https:') { return null; }
    if (SHARE.test(p.u.href)) { return 'share'; }
    if (WA.test(p.host)) { return 'whatsapp'; }
    var path = p.u.pathname || '/';
    if (isOwn(p)) {
      if (LEAD.test(path)) { return 'quote_form'; }
      if (TOOL.test(path)) { return 'tool'; }
      if (DOC.test(path) || /\.pdf($|\?)/i.test(path)) { return 'document'; }
      return 'internal';
    }
    if (/(^|\.)(cdn\.shopify\.com|shopifycdn\.com)$/i.test(p.host) || /\.pdf($|\?)/i.test(path)) { return 'document'; }
    if (SHOPEE.test(p.host)) { return 'shopee'; }
    if (KZ.test(p.host)) { return 'kudzuseeds'; }
    if (SOCIAL.test(p.host)) { return 'social'; }
    if (isCitationUrl(p)) { return 'citation'; }
    return 'outbound';
  }
  /* Returns the tagged href for a link, or null when the link must not be tagged. Pure: the caller
     decides whether to apply it. */
  function taggedHref(p, opts) {
    opts = opts || {};
    if (!p) { return null; }
    if (p.proto !== 'http:' && p.proto !== 'https:') { return null; }
    if (isOwn(p)) { return null; }
    if (SKIP.test(p.host) || SHARE.test(p.u.href)) { return null; }
    if (isCitationUrl(p) || opts.reference) { return null; }
    if (opts.noUtm) { return null; }
    if (/[?&]utm_[a-z_]+=/i.test(p.u.search)) { return null; }
    var qs = 'utm_source=chemiseed.com&utm_medium=referral&utm_campaign=' + encodeURIComponent(opts.campaign || campaign()) + '&utm_content=' + encodeURIComponent(opts.content || 'body');
    var raw = p.raw, hi = raw.indexOf('#'), base = hi > -1 ? raw.slice(0, hi) : raw, hash = hi > -1 ? raw.slice(hi) : '';
    if (/\?$/.test(base)) { base += qs; } else { base += (base.indexOf('?') > -1 ? '&' : '?') + qs; }
    return base + hash;
  }
  /* Indonesia market: Malaysian WhatsApp number to the Indonesia contact, keeping path and query. */
  function waIndonesia(href) {
    if (!href || href.indexOf(WA_MY) === -1) { return href; }
    return href
      .replace(/^(https?:\/\/(?:www\.)?wa\.me\/)\+?60172374058(?=$|[\/?#])/i, '$1' + WA_ID)
      .replace(/^((?:https?:\/\/(?:api|web)\.whatsapp\.com\/send\/?|whatsapp:\/\/send\/?)\?(?:[^#]*?&)?phone=)\+?60172374058(?=$|[&#])/i, '$1' + WA_ID);
  }
  function waTextIndonesia(text) {
    if (text == null || !/[0-9]/.test(text)) { return text; }
    return String(text).replace(WA_MY_TEXT, '$1' + WA_ID_TEXT);
  }
  /* Text nodes inside one link only (scripts and styles skipped). */
  function rewriteWaText(el) {
    var kids = (el && el.childNodes) || [];
    for (var i = 0; i < kids.length; i++) {
      var k = kids[i];
      if (k.nodeType === 3) {
        var v = k.nodeValue, w = waTextIndonesia(v);
        if (w !== v) { k.nodeValue = w; }
      } else if (k.nodeType === 1 && !/^(SCRIPT|STYLE)$/i.test(k.tagName || '')) {
        rewriteWaText(k);
      }
    }
  }
  /* Points one link at the Indonesia contact; its text follows. Returns true when the href changed. */
  function rewriteWaLink(a) {
    var h = a.getAttribute('href'), n = waIndonesia(h);
    if (n === h) { return false; }
    a.setAttribute('href', n);
    rewriteWaText(a);
    return true;
  }
  function rewriteWaLinks(root) {
    if (!isIndonesiaPage()) { return; }
    var as = (root || d).querySelectorAll ? (root || d).querySelectorAll('a[href*="' + WA_MY + '"]') : [];
    for (var i = 0; i < as.length; i++) { rewriteWaLink(as[i]); }
  }
  function anchorOf(e) {
    var t = e.target;
    if (!t || !t.closest) { t = t && t.parentElement; }
    return t && t.closest ? t.closest('a[href]') : null;
  }
  function isCta(a) { return !!closestSafe(a, CTA); }
  /* Gives the link the page's locale/market prefix for this activation only; the original href is
     restored on the next tick, after the browser has read it for the navigation. */
  function localize(a, p) {
    if (!a || !p || a.__csOrig != null) { return; }
    var n = localizedHref(p, null, a);
    if (!n || n === a.getAttribute('href')) { return; }
    a.__csOrig = a.getAttribute('href');
    a.setAttribute('href', n);
    setTimeout(function () {
      if (a.__csOrig != null) { a.setAttribute('href', a.__csOrig); }
      a.__csOrig = null;
    }, 0);
  }
  /* Tag the link for this activation only; the clean href is restored on the next tick, after the
     browser has read it for the navigation. */
  function decorate(a, p) {
    if (!a || !p || a.__csOrig != null) { return; }
    var tagged = taggedHref(p, { noUtm: a.hasAttribute('data-no-utm'), reference: inReferenceList(a), content: content(a) });
    if (!tagged) { return; }
    a.__csOrig = a.getAttribute('href');
    a.setAttribute('href', tagged);
    setTimeout(function () {
      if (a.__csOrig != null) { a.setAttribute('href', a.__csOrig); }
      a.__csOrig = null;
    }, 0);
  }
  function clarity(fn) {
    var tries = 0;
    (function tick() {
      if (typeof window.clarity === 'function') { try { fn(window.clarity); } catch (e) {} return; }
      if (++tries < 40) { setTimeout(tick, 250); }
    })();
  }
  function track(e) {
    if (e.type === 'auxclick' && e.button !== 1) { return; }
    var a = anchorOf(e); if (!a) { return; }
    if (isIndonesiaPage()) { rewriteWaLink(a); }
    var p = parse(a); if (!p) { return; }
    var cleanHref = a.__csOrig != null ? a.__csOrig : (a.getAttribute('href') || '');
    localize(a, p);
    decorate(a, p);
    var type = classify(p); if (!type) { return; }
    if (type === 'internal') { if (!isCta(a)) { return; } type = 'internal_cta'; }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'cs_cta_click',
      cta_type: type,
      cta_label: label(a),
      link_url: String(cleanHref).slice(0, 500),
      link_domain: p.host || L.hostname,
      link_placement: placement(a)
    });
    clarity(function (c) { c('set', 'cta_type', type); c('event', 'cta_click'); });
  }
  function onKey(e) {
    if (e.key !== 'Enter') { return; }
    var a = anchorOf(e); if (!a) { return; }
    var p = parse(a);
    localize(a, p);
    decorate(a, p);
  }
  d.addEventListener('click', track, true);
  d.addEventListener('auxclick', track, true);
  d.addEventListener('keydown', onKey, true);
  if (isIndonesiaPage()) {
    rewriteWaLinks(d);
    if (d.readyState === 'loading') { d.addEventListener('DOMContentLoaded', function () { rewriteWaLinks(d); }); }
    if (window.MutationObserver) {
      var waTimer = null;
      new MutationObserver(function () {
        if (waTimer) { return; }
        waTimer = setTimeout(function () { waTimer = null; rewriteWaLinks(d); }, 200);
      }).observe(d.documentElement, { childList: true, subtree: true });
    }
  }
  clarity(function (c) {
    if (ctx.page_group) { c('set', 'page_group', String(ctx.page_group)); }
    if (ctx.handle) { c('set', 'page_handle', String(ctx.handle)); }
    if (ctx.locale) { c('set', 'locale', String(ctx.locale) + (ctx.market ? '-' + ctx.market : '')); }
  });
  window.csLinks = {
    classify: function (a) { return classify(parse(a)); },
    decorate: function (a) { var p = parse(a); return taggedHref(p, { noUtm: a.hasAttribute('data-no-utm'), reference: inReferenceList(a), content: content(a) }) || a.getAttribute('href'); },
    campaign: campaign,
    placement: placement,
    content: content,
    _test: { parseHref: function (href, base) { var u = new URL(href, base || L.href); return { raw: href, u: u, host: (u.hostname || '').toLowerCase(), proto: u.protocol }; }, taggedHref: taggedHref, isCitationUrl: isCitationUrl, classify: classify, campaign: campaign, contentTag: contentTag, waIndonesia: waIndonesia, waTextIndonesia: waTextIndonesia, rewriteWaLinks: rewriteWaLinks, localizedHref: localizedHref, pathRoot: pathRoot, pageLocale: pageLocale, pageMarket: pageMarket, refHeading: function (t) { return REF_HEAD.test(t); } }
  };
})();
